// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MUUwp","content":"styles_content__17vdR"};